<template>
  <div>
    <b-collapse
      animation="slide"
      :open="isOpen"
      class="card"
      :style="disabled ? { pointerEvents: 'none' } : {}"
      @open="$emit('open', geofence)"
      @close="$emit('cancel')"
    >
      <template #trigger>
        <div role="button" class="card-header">
          <h2 class="card-header-title">{{ geofence.name }}</h2>

          <div class="card-header-icon">
            <b-button
              :disabled="loading || disabled"
              type="is-primary"
              icon-left="pen"
              class="mr-2"
            />
            <b-button
              :loading="loading"
              :disabled="loading || disabled"
              type="is-danger"
              icon-left="trash"
              @click.stop="showConfirmDelete = true"
            />
          </div>
        </div>
      </template>
      <div class="notification content">
        <slot />
      </div>
    </b-collapse>
    <o-modal
      title="Suppression d'un geofence"
      :isOpen="showConfirmDelete"
      submit-label="Supprimer"
      variant="danger"
      @closeModal="showConfirmDelete = false"
      @confirmModalAction="remove"
    >
      <template>
        La suppression du geofence {{ geofence.name }} est <strong>définitive</strong>.
      </template>
    </o-modal>
  </div>
</template>

<script>
import OModal from '@components/Modal.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ListItem',

  components: {
    OModal,
  },

  props: {
    geofence: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      showConfirmDelete: false,
    }
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async remove() {
      this.loading = true

      try {
        const liveStageGeofence = await this.$services.liveTrackerGeofenceService.delete(
          this.geofence.id,
        )

        this.$emit('delete', liveStageGeofence)

        this.addToastMessage({
          text: `Le geofence "${liveStageGeofence.name}" a été supprimé.`,
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message ?? `La suppression du geofence ${this.geofence.name} a échouée.`,
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },
  },
}
</script>
